import React, { useState, useEffect, useRef } from "react";
import PropertyCard from "./PropertyCard";
import "./LatestProperties.css";
import "./MobileviewLatestproperties.css"
import Tulsi1 from "./Images/tulsi1.jpg";
import { FaChevronLeft, FaChevronRight, FaCalendarAlt } from "react-icons/fa";

// All properties combined (same as before)
const allProperties = [
    // {
    //     id: 101,
    //     title: "Manufacturing Plant",
    //     location: "MIDC Area, Pune",
    //     image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12",
    //     type: "For Sale",
    //     isFeatured: true,
    //     imageCount: 6,
    //     listedDate: new Date().toISOString().split('T')[0],
    //     viewCount: 2100,
    //     propertyType: "industrial",
    //     size: "10,000 sqft",
    //     isNew: true,
    //     amenities: ["Heavy Power", "Loading Dock", "Storage", "Security"]
    // },
    // {
    //     id: 102,
    //     title: "Warehouse Complex",
    //     location: "Bhiwandi, Mumbai",
    //     image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa",
    //     type: "For Rent",
    //     isFeatured: false,
    //     imageCount: 5,
    //     listedDate: getDateDaysAgo(0),
    //     viewCount: 1850,
    //     propertyType: "industrial",
    //     size: "25,000 sqft",
    //     isNew: true,
    //     amenities: ["Heavy Power", "Loading Dock", "Storage", "Security"]
    // },
    {
        id: 101,
        areaLocation: " Patiya Ankleshwar",
        title: "Tulsi Patra 3 BHK",
        location: "Gadkhol Patiya Opp:Aiyappa manidr, Ankleshwar",
        image: Tulsi1,
        type: "For Sale",
        isFeatured: true,
        imageCount: 3,
        listedDate: "2026-05-24",
        viewCount: 4250,
        propertyType: "residential",
        beds: 4,
        baths: 3,
        area: "815 OR 625 sqft",
        amenities: ["24 Hrs Water Facility", "2 AC Point",]
    },
    {
        id: 102,
        areaLocation: " Rajpipla Chokadi Ankleshwar",
        title: "Satyam Residency",
        location: "Rajpipla Chowkadi NH-48,opp.Varsha Hotel",
        image: "https://images.unsplash.com/photo-1501183638710-841dd1904471",
        type: "For Sale",
        isFeatured: true,
        imageCount: 6,
        listedDate: "2026-05-24",
        viewCount: 2890,
        propertyType: "residential",
        beds: 3,
        baths: 2,
        area: "551 sqft",
        amenities: ["Temple", "Garden", "Parking"]
    },
    {
        id: 103,
        areaLocation: " Andara Ankleshwar",
        title: "Nilkanth Varni Bungalow",
        location: "800 mtrs ahead of Gadkhol Patiya, Opp. Aiyappa Mandir, Ankleshwar.",
        image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c",
        type: "For Sale",
        isFeatured: true,
        imageCount: 10,
        listedDate: "2026-05-24",
        viewCount: 5100,
        propertyType: "residential",
        beds: 3,
        baths: 3,
        area: "560 sqft",
        // amenities: [""]
    },
    {
        id: 104,
        areaLocation: "Ankleshwar-Bharuch Road",
        title: "Golden Nirvana 2/3 BHK ",
        location: "Near Golden Villa, Ankleshwar-Bharuch Road",
        image: "https://images.unsplash.com/photo-1572120360610-d971b9b77677",
        type: "For Sale",
        isFeatured: false,
        imageCount: 7,
        listedDate: "2026-05-24",
        viewCount: 3560,
        propertyType: "residential",
        beds: 5,
        baths: 4,
        area: "850 sqft",
        // amenities: ["Private Garden", "Swimming Pool", "Servant Quarter", "Parking"]
    },
];

// Helper function to get dates
function getDateDaysAgo(days) {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date.toISOString().split('T')[0];
}

// Calculate days difference
function getDaysDifference(listedDate) {
    const today = new Date();
    const listed = new Date(listedDate);
    const diffTime = Math.abs(today - listed);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}

export default function LatestProperties() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);
    const [itemsPerSlide, setItemsPerSlide] = useState(3);
    const carouselRef = useRef(null);

    // Filter properties listed in last 15 days
    const latestProperties = allProperties.filter(property => {
        const daysAgo = getDaysDifference(property.listedDate);
        return daysAgo <= 15;
    });

    // Calculate items per slide based on screen width
    useEffect(() => {
        const updateItemsPerSlide = () => {
            if (window.innerWidth < 768) {
                setItemsPerSlide(1);
            } else if (window.innerWidth < 1024) {
                setItemsPerSlide(2);
            } else {
                setItemsPerSlide(3);
            }
        };

        updateItemsPerSlide();
        window.addEventListener('resize', updateItemsPerSlide);
        return () => window.removeEventListener('resize', updateItemsPerSlide);
    }, []);

    // Create slides based on itemsPerSlide
    const createSlides = () => {
        if (latestProperties.length === 0) return [];
        
        const slides = [];
        
        // If itemsPerSlide >= total properties or mobile view, show one property per slide
        if (itemsPerSlide >= latestProperties.length || itemsPerSlide === 1) {
            // One property per slide (for mobile or when few properties)
            return latestProperties.map(property => [property]);
        }
        
        // Create slides with multiple properties
        for (let i = 0; i < latestProperties.length; i += itemsPerSlide) {
            const slide = latestProperties.slice(i, i + itemsPerSlide);
            slides.push(slide);
        }
        
        return slides;
    };

    const slides = createSlides();
    const totalSlides = slides.length;

    // Next and Previous functions
    const nextSlide = () => {
        if (totalSlides <= 1) return;
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
    };

    const prevSlide = () => {
        if (totalSlides <= 1) return;
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const toggleAutoPlay = () => {
        setAutoPlay(!autoPlay);
    };

    // Auto-play effect
    useEffect(() => {
        if (!autoPlay || totalSlides <= 1) return;

        const interval = setInterval(() => {
            nextSlide();
        }, 4000);

        return () => clearInterval(interval);
    }, [autoPlay, currentSlide, totalSlides]);

    // Handle keyboard navigation
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'ArrowLeft') {
                prevSlide();
            } else if (e.key === 'ArrowRight') {
                nextSlide();
            } else if (e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                toggleAutoPlay();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [autoPlay]);

    if (latestProperties.length === 0) {
        return (
            <section className="latest-properties-carousel">
                <div className="section-header">
                    <div className="header-left">
                        <h2 className="section-title">Latest Listing Properties</h2>
                        <p className="section-subtitle">Recently added properties in last 15 days</p>
                    </div>
                    <div className="new-properties-count">
                        <FaCalendarAlt /> No new properties in last 15 days
                    </div>
                </div>
                <div className="no-new-properties">
                    <p>Check back soon for new property listings!</p>
                </div>
            </section>
        );
    }

    return (
        <section className="latest-properties-carousel">
            <div className="section-header">
                <div className="header-left">
                    <h2 className="section-title">Latest Listing Properties</h2>
                    <p className="section-subtitle">Recently added properties in last 15 days</p>
                </div>
                <div className="new-properties-count">
                    <FaCalendarAlt /> {latestProperties.length} New Properties
                </div>
            </div>

            {/* Carousel Container */}
            <div
                className="carousel-container"
                onMouseEnter={() => setAutoPlay(false)}
                onMouseLeave={() => setAutoPlay(true)}
                ref={carouselRef}
            >
                <div className="carousel-track-container">
                    <div
                        className="carousel-track"
                        style={{
                            transform: `translateX(-${currentSlide * 100}%)`,
                            transition: 'transform 0.5s ease-in-out'
                        }}
                    >
                        {slides.map((slideProperties, slideIndex) => (
                            <div key={`slide-${slideIndex}`} className="carousel-slide">
                                <div className="slide-content">
                                    {slideProperties.map(property => (
                                        <div key={`${property.id}-${slideIndex}`} className="carousel-card-wrapper">
                                            <PropertyCard data={property} />
                                            <div className="new-badge">
                                                NEW • {getDaysDifference(property.listedDate)} days ago
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Navigation Buttons */}
                {totalSlides > 1 && (
                    <>
                        <button
                            className="carousel-btn prev-btn"
                            onClick={prevSlide}
                            aria-label="Previous slide"
                        >
                            <FaChevronLeft />
                        </button>
                        <button
                            className="carousel-btn next-btn"
                            onClick={nextSlide}
                            aria-label="Next slide"
                        >
                            <FaChevronRight />
                        </button>
                    </>
                )}

                {/* Auto Play Toggle */}
                <div className="auto-play-toggle">
                    <button
                        className={`auto-play-btn ${autoPlay ? 'active' : ''}`}
                        onClick={toggleAutoPlay}
                        aria-label={autoPlay ? "Pause auto play" : "Start auto play"}
                        disabled={totalSlides <= 1}
                    >
                        {autoPlay ? '⏸️' : '▶️'}
                    </button>
                </div>
            </div>

            {/* Indicators */}
            {totalSlides > 1 && (
                <div className="carousel-indicators">
                    {slides.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentSlide ? 'active' : ''}`}
                            onClick={() => goToSlide(index)}
                            aria-label={`Go to slide ${index + 1}`}
                        />
                    ))}
                </div>
            )}
        </section>
    );
}